module.exports = __webpack_public_path__ + "img/big_1_3.6ab13200.png";